export const SIMPLE_APPOINTMENT = 2;
export const PAID_APPOINTMENT = 1;

export const CLINICIAN_SLOT = 1;
export const DOCTOR_SLOT = 2;
export const ADD_COSULTATION_LABEL = "Add consultation";
